export default __webpack_public_path__ + "static/media/map_main_building.fad3ae35.png";